import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import english from './locales/en.json'
import polish from './locales/pl.json'
import french from './locales/fr.json'
import spaniash from './locales/es.json'
import korean from './locales/ko.json'
import chinese from './locales/zh.json'
import portuguese from './locales/pt.json'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: english.translation
      },
      pl: {
        translation: polish.translation
      },
      fr: {
        translation: french.translation
      },
      es: {
        translation: spaniash.translation
      },
      ko: {
        translation: korean.translation
      },
      zh: {
        translation: chinese.translation
      },
      pt: {
        translation: portuguese.translation
      }
      // Add more languages as needed
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if translation is not available
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;